import React from 'react'
import {simpleCurrency} from 'app/format/currency'
import replace from 'lodash/replace'
import NumberFormat from 'react-number-format'
import clsx from 'clsx'

interface Props {
  refundPrice: number | any
  onAmountChange: (val: any) => void
  maxRefundPrice: number | any
  title?: string
  className?: string
}

export const RefundInput: React.FC<Props> = ({
  onAmountChange,
  refundPrice = 0,
  maxRefundPrice = 0,
  title = 'Refund Shipping Fee',
  className,
}) => {
  const handleRefund = (e: any) => {
    let {value} = e.target
    value = replace(value, '$', '')
    onAmountChange(value)
  }
  const validate = (e: any) => {
    const {value} = e
    if (value <= maxRefundPrice) {
      return true
    }
    return false
  }
  return (
    <div className={clsx(className)}>
      <label className='form-label'>{title}</label>
      <NumberFormat
        className='form-control w-100 mb-3'
        placeholder='$0.0'
        prefix='$'
        value={refundPrice}
        isAllowed={validate}
        decimalScale={2}
        allowNegative={false}
        onChange={handleRefund}
        onValueChange={({floatValue}) => {
          onAmountChange(floatValue)
        }}
      />
      {maxRefundPrice > 0 && (
        <div className='mb-4'>Maximum refund: {simpleCurrency(maxRefundPrice)}</div>
      )}
    </div>
  )
}

export default RefundInput
